<template>
  <li class="dropdown-item"><router-link :to="to"><slot/></router-link></li>
</template>

<script>
export default {
  name: 'DropdownItem',

  props: {
    to: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
  .dropdown-item {
    font-family: 'Sitka Text', serif;
    font-size: 1.15rem;
    text-align: left;

    width: 100%;
    margin: 0;
    padding: 0;

    cursor: pointer;

    a {
      color: #333;
      text-decoration: none;

      transition: color 350ms ease;
      padding: 0.5rem 1.25rem;
      display: block;
    }

    transition: background-color 350ms ease;

    &:hover {
      background-color: rgba(255, 251, 243, 0.4);
      a {
        color: black;
      }
    }
  }

  .solid {
    .dropdown-item:hover{
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
</style>
